import { render, staticRenderFns } from "./FEMADisasterList.vue?vue&type=template&id=49561932&scoped=true"
import script from "./FEMADisasterList.vue?vue&type=script&lang=js"
export * from "./FEMADisasterList.vue?vue&type=script&lang=js"
import style0 from "./FEMADisasterList.vue?vue&type=style&index=0&id=49561932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49561932",
  null
  
)

export default component.exports